import axios from 'axios'
import {ResponseObjectPaginated} from '../../../../../models'
import {GuestModel, GetPaginationGuestDto} from '../model/guest.model'

const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

const BASEURLCENTRAL = process.env.REACT_APP_DEV_API_CENTRAL_URL

export function paginationGuestsService(dto: GetPaginationGuestDto) {
  return axios.post<ResponseObjectPaginated<GuestModel[]>>(`${BASEURL}/guest/getList`, dto)
}
export function getAllUserV2(dto: any) {
  return axios.post<ResponseObjectPaginated<any[]>>(`${BASEURLCENTRAL}/user/getAll_v2/1`, dto)
}
export function getListGuestsExcelService(dto: any) {
  return axios.post<any>(`${BASEURL}/guest/getListExcel`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    responseType: 'arraybuffer',
  })
}

export function getTemplateGuestsService() {
  return axios.post<any>(
    `${BASEURL}/guest/downloadTemplateBulkLoad_file`,
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'arraybuffer',
    },
  )
}
